import { useSyncExternalStore } from 'react'
import { Moon, Sun } from 'lucide-react'
import { getTheme, setTheme, subscribeToTheme } from '../../services/theme'

export function ThemeToggle() {
  const theme = useSyncExternalStore(subscribeToTheme, getTheme, () => 'light')
  const dark = theme === 'dark'

  return <div className="theme-control">
    <button
      type="button"
      className="theme-switch"
      role="switch"
      aria-label="Dark mode"
      aria-checked={dark}
      title={`Switch to ${dark ? 'light' : 'dark'} mode`}
      onClick={() => setTheme(dark ? 'light' : 'dark')}
    >
      <span className="theme-switch__thumb" aria-hidden="true" />
      <Sun className="theme-switch__sun" aria-hidden="true" />
      <Moon className="theme-switch__moon" aria-hidden="true" />
    </button>
    <span className="theme-control__label" aria-hidden="true">{dark ? 'Dark' : 'Light'}</span>
  </div>
}
